import Modals from "../../../components/common/Modal";
import AllocateFundBuyer from "./allocateFundBuyer";

function AllocateFundBuyerModel({ open, setOpen }) {
  // const userRole = "BUYER";
  const userRole = atob(sessionStorage.getItem("argument6"));
  // const userRole = localStorage.getItem('argument6');
  return (
    <>
      <Modals
        title={"Allocate Of Fund"}
        show={open === "AllocateFundBuyerModel"}
        handleClose={() => setOpen("")}
        size="xl"
      >
        {userRole === "BUYER" && (
          <AllocateFundBuyer handleClose={() => setOpen("")} />
        )}
        {/* {userRole === "BUYER" && <ViewDealBookBuyer modalRight={
          open === "createAuctionCenter" ||
          (open === "editingAuctionCenterData" || modalRight?.length > 0
            ? modalRight
            : [])
        }/>} */}
      </Modals>
    </>
  );
}

export default AllocateFundBuyerModel;
